"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementScrollPosition = exports.useWindowScrollAtTop = exports.useWindowScrollPosition = void 0;
var react_1 = require("react");
// https://github.com/neo/react-use-scroll-position
var useWindowScrollPosition = function () {
    var _a = (0, react_1.useState)(window.pageYOffset), position = _a[0], setPosition = _a[1];
    (0, react_1.useEffect)(function () {
        var requestRunning = null;
        var handleScroll = function () {
            if (requestRunning === null) {
                requestRunning = window.requestAnimationFrame(function () {
                    setPosition(window.pageYOffset);
                    requestRunning = null;
                });
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return position;
};
exports.useWindowScrollPosition = useWindowScrollPosition;
var useWindowScrollAtTop = function () {
    var _a = (0, react_1.useState)(true), atTop = _a[0], setAtTop = _a[1];
    (0, react_1.useEffect)(function () {
        var requestRunning = null;
        var handleScroll = function () {
            if (requestRunning === null) {
                requestRunning = window.requestAnimationFrame(function () {
                    setAtTop(window.pageYOffset === 0);
                    requestRunning = null;
                });
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return atTop;
};
exports.useWindowScrollAtTop = useWindowScrollAtTop;
var useElementScrollPosition = function (element) {
    var _a = (0, react_1.useState)(0), position = _a[0], setPosition = _a[1];
    (0, react_1.useEffect)(function () {
        var requestRunning = null;
        var handleScroll = function () {
            if (requestRunning === null) {
                requestRunning = window.requestAnimationFrame(function () {
                    setPosition(element ? element.scrollTop : 0);
                    requestRunning = null;
                });
            }
        };
        if (element) {
            element.addEventListener('scroll', handleScroll);
        }
        return function () {
            if (element) {
                element.removeEventListener('scroll', handleScroll);
            }
        };
    }, [element]);
    return position;
};
exports.useElementScrollPosition = useElementScrollPosition;
